import { useReveal } from "../hooks/useReveal";
import { ParallaxBg } from "../components/ParallaxBg";

const TRUST = [
  "Free educational session — no obligation",
  "No loan application required",
  "No credit pull needed to attend",
  "Opportunity to ask questions and learn your next steps",
];

export default function FinalRegister() {
  const ref = useReveal();
  return (
    <section id="register" ref={ref} className="final-section py-28 md:py-40" data-testid="final-register-section">
      <ParallaxBg image="/bg/home2.jpg" />
      <div className="final-glow" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <p className="section-label mb-10 reveal-up">[009] — RESERVE YOUR SEAT</p>
          <h2 className="reveal-up font-black uppercase mb-12" style={{ fontSize: "clamp(36px, 4.6vw, 64px)", letterSpacing: "-0.03em", lineHeight: 0.98 }}>
            YOUR NEXT MOVE STARTS WITH A CLEARER <span style={{ color: "#3D7BFF" }}>MAP.</span>
          </h2>
          <ul className="space-y-4">
            {TRUST.map((t, i) => (
              <li key={i} className="reveal-up flex gap-3 items-center text-sm md:text-base" style={{ color: "rgba(240,236,228,0.75)" }} data-testid={`trust-bullet-${i + 1}`}>
                <span style={{ color: "#3D7BFF", fontWeight: 800 }}>✓</span>
                {t}
              </li>
            ))}
          </ul>
        </div>
        <div className="glass-card p-7 md:p-9 reveal-up" data-testid="final-registration-card">
          <p className="eyebrow mb-2" style={{ color: "#FFFFFF", fontSize: 12 }}>FREE 60-MINUTE LIVE SESSION</p>
          <h3 className="font-extrabold text-xl mb-2">Reserve Your Free Seat — September 17th · 7PM EST</h3>
          <p style={{ fontSize: 14, color: "rgba(240,236,228,0.6)", lineHeight: 1.7 }}>
            Live on September 17th at 7:00 PM EST — free educational session for VA-eligible buyers.
          </p>
        </div>
      </div>
    </section>
  );
}
